export default __webpack_public_path__ + "be06d00cc45be05c2b9ebf3a89011a65.svg";